"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _jquery = _interopRequireDefault(require("jquery"));
var _PlayerFactory2 = _interopRequireDefault(require("../models/PlayerFactory"));
var _isMobile = _interopRequireDefault(require("../../utils/isMobile"));
var _JPlayer = _interopRequireDefault(require("./JPlayer"));
var _JPlayerMobilePlayer = _interopRequireDefault(require("./JPlayerMobilePlayer"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle */
/**
 * See JPlayer documentation for information on these configuration options:
 *  http://jplayer.org/latest/developer-guide/#jPlayer-constructor
 */
var JPlayerConfiguration = {
  swfPath: 'https://ajax.cdnjs.com/ajax/libs/jplayer/2.9.2/jplayer/jquery.jplayer.swf',
  mobile: {
    supplied: 'mp3,m4a,oga,m3u8a,m3ua',
    solution: 'html'
  },
  desktop: {
    supplied: 'mp3,m4a,oga,rtmpa,m3u8a,m3ua',
    solution: 'html,flash'
  }
};
function createJPlayerLibrary(config) {
  var containerElement = document.createElement('div');
  containerElement.setAttribute('style', 'width: 0px; height: 0px; display: none;');
  document.body.appendChild(containerElement);
  var jPlayerInstance = (0, _jquery["default"])(containerElement).jPlayer(config);
  return {
    jPlayerInstance: jPlayerInstance,
    mediaElement: containerElement.querySelector('audio')
  };
}
var JPlayerFactory = exports["default"] = /*#__PURE__*/function (_PlayerFactory) {
  (0, _inherits2["default"])(JPlayerFactory, _PlayerFactory);
  function JPlayerFactory() {
    var _this;
    (0, _classCallCheck2["default"])(this, JPlayerFactory);
    _this = _callSuper(this, JPlayerFactory);
    _this.jPlayerMobileInstance = null;
    return _this;
  }
  (0, _createClass2["default"])(JPlayerFactory, [{
    key: "createPlayer",
    value: function createPlayer() {
      var playerConfig = {
        swfPath: JPlayerConfiguration.swfPath
      };
      if (!(0, _isMobile["default"])()) {
        playerConfig.supplied = JPlayerConfiguration.desktop.supplied;
        playerConfig.solution = JPlayerConfiguration.desktop.solution;
        var _jPlayerConfig = createJPlayerLibrary(playerConfig);
        return new _JPlayer["default"](_jPlayerConfig);
      }
      if (this.jPlayerMobileInstance) {
        return this.jPlayerMobileInstance;
      }
      playerConfig.supplied = JPlayerConfiguration.mobile.supplied;
      playerConfig.solution = JPlayerConfiguration.mobile.solution;
      var jPlayerConfig = createJPlayerLibrary(playerConfig);
      this.jPlayerMobileInstance = new _JPlayerMobilePlayer["default"](jPlayerConfig);
      return this.jPlayerMobileInstance;
    }
  }]);
  return JPlayerFactory;
}(_PlayerFactory2["default"]);
//# sourceMappingURL=JPlayerFactory.js.map